/**
 * API for work with users data.
 *
 */

import { UserProfile, UserResponse } from '@/types/admin';
import { makeFormRequest, makeGetRequest } from './helpers';

/**
 * Get user profile
 */
export const profile = async (): Promise<UserProfile> => {
    const result = await makeGetRequest('/api/auth/profile');

    return result.data.result;
};

/**
 * Admin user authorization.
 *
 * @param login
 * @param password
 */
export const login = async (login: string, password: string): Promise<UserResponse> => {
    const result = await makeFormRequest('/api/auth/login', { login, password });

    return result.data;
};
